module.exports = __webpack_public_path__ + "media/Instruction_001.40a029af.mp3";